import { render, staticRenderFns } from "./HalfNHalf.vue?vue&type=template&id=6699434d"
import script from "./HalfNHalf.vue?vue&type=script&lang=js"
export * from "./HalfNHalf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports